export const PRE_SESSION_FIRST_DIGIT = 3;
export const POST_SESSION_FIRST_DIGIT = 4;
export const PRE_TEST_NUM = 100;
export const POST_TEST_NUM = 200;
export const PRE_SESSION_NUM = 300;
export const POST_SESSION_NUM = 400;
export const FEEDBACK_NUM = 500;
